export const GET_VOTE_RADIO = 'GET_VOTE_RADIO';
export const CHANGE_VOTE_INDEX = 'CHANGE_VOTE_INDEX';
